export default "__VITE_ASSET__37001551__"